import { GameId } from '@sss/shared'
import { GameRegistry } from '@/games'
import type { GameSceneConfig } from '@/games'

const DEFAULT_GAME: GameId = 'candy'

let currentGameId: GameId = DEFAULT_GAME

function readFromQuery(): GameId {
  if (typeof window === 'undefined') return DEFAULT_GAME
  const params = new URLSearchParams(window.location.search)
  const raw = params.get('game_id') ?? params.get('gameId')
  if (!raw) return DEFAULT_GAME
  const parsed = GameId.safeParse(raw)
  return parsed.success ? parsed.data : DEFAULT_GAME
}

export const GameContext = {
  init(): GameId {
    currentGameId = readFromQuery()
    return currentGameId
  },

  gameId(): GameId {
    return currentGameId
  },

  config(): GameSceneConfig {
    return GameRegistry[currentGameId]
  },
}
